import { api } from '@marketplace-web/core-api/core-api-client-data'

import { GetUserStatsResp } from '../types/user-stats'

const moneyObjectHeader = {
  'X-Money-Object': 'true',
}

export const getUserStats = (userId: number) => {
  return api.get<GetUserStatsResp>(`/users/${userId}/stats`, {
    headers: moneyObjectHeader,
  })
}
